export const ru = {
  nav: {
    features: 'Возможности',
    howItWorks: 'Как это работает',
    pricing: 'Цены',
    community: 'Сообщество',
    startFree: 'Начать бесплатно',
  },
  hero: {
    title: 'Твой Longevity Co-pilot',
    titleHighlight: '',
    titleEnd: '',
    description: 'Мы превращаем твои данные и цели в план, чтобы жить дольше.',
    tryFree: 'Попробовать 7 дней',
    watchDemo: 'Смотреть демо',
    price: 'в месяц',
    automatic: 'автоматически',
    personalPlan: 'персональный план',
  },
  beforeAfter: {
    badge: 'Ожидаемые результаты',
    title: 'До и После',
    description: 'Посмотрите, как может измениться ваша жизнь за первые 6 месяцев использования Juvenis',
    energy: 'Энергия',
    sleep: 'Сон',
    longevity: 'Долголетие',
    before: 'ДО',
    after: 'ПОСЛЕ',
    beforeLabel: 'До',
    afterLabel: 'После',
    resultsNote: 'Результаты основаны на научных исследованиях и анализе биомаркеров здоровья',
    resultsNoteSmall: 'Индивидуальные результаты могут варьироваться в зависимости от исходных данных и соблюдения рекомендаций',
    energyBefore: {
      value: '45%',
      label: 'Постоянная усталость',
      description: 'Просыпаетесь разбитым, кофе не помогает',
    },
    energyAfter: {
      value: '92%',
      label: 'Бодрость весь день',
      description: 'Энергия с утра до вечера без стимуляторов',
    },
    sleepBefore: {
      value: '5.2ч',
      label: 'Плохой сон',
      description: 'Частые пробуждения, не высыпаетесь',
    },
    sleepAfter: {
      value: '8.1ч',
      label: 'Глубокий сон',
      description: 'Просыпаетесь отдохнувшим и свежим',
    },
    longevityBefore: {
      value: '68 лет',
      label: 'Биологический возраст',
      description: 'Организм стареет быстрее календаря',
    },
    longevityAfter: {
      value: '52 года',
      label: 'Биологический возраст',
      description: 'Моложе на 16 лет за 6 месяцев',
    },
  },
  features: {
    title: 'Ежедневный план',
    subtitle: 'Каждый день ты получаешь 3 действия, которые реально двигают твою траекторию.',
    cardTitle: 'Что ты видишь в приложении',
    sections: {
      today: 'СЕГОДНЯ',
      why: 'ПОЧЕМУ',
      done: 'ЗАДАЧИ',
      adapt: 'АДАПТАЦИЯ',
    },
    today: {
      sleep: 'Сон',
      food: 'Еда',
      movement: 'Движение',
    },
    why: {
      sleep: 'Вчера сон был короче на 1.5ч — снижаем нагрузку, приоритет на восстановление',
      food: 'Низкий уровень белка вчера — увеличиваем порции, добавляем протеин',
      movement: 'Малоподвижный день — добавляем легкую активность, прогулки',
    },
    done: {
      sleep: {
        busy: {
          task1: 'Получить солнечный свет до 10:00 (15-20 минут)',
          task2: 'Принять магний 400мг за 1 час до сна',
          task3: 'Лечь спать до 23:00, выключить экраны за 30 мин',
        },
        travel: {
          task1: 'Солнечный свет утром (10-15 минут)',
          task2: 'Ужин до 19:00, легкая пища',
          task3: 'Лечь спать до 22:30, затемнить комнату',
        },
      },
      food: {
        busy: {
          task1: '30г белка на завтрак (яйца/творог/протеин)',
          task2: '150г овощей в каждый прием пищи',
          task3: 'Выпить 2.5л воды в течение дня',
        },
        travel: {
          task1: 'Белок в каждый прием пищи (минимум 20г)',
          task2: 'Легкие перекусы каждые 3-4 часа',
          task3: 'Выпить 2л воды, избегать обезвоживания',
        },
      },
      movement: {
        busy: {
          task1: 'Прогулка на свежем воздухе 20 минут',
          task2: '10 минут растяжки или йоги',
          task3: 'Пройти минимум 5000 шагов за день',
        },
        travel: {
          task1: 'Дыхательные упражнения 5 минут (4-7-8)',
          task2: 'Лечь спать на 30 минут раньше обычного',
          task3: 'Легкая ходьба 10-15 минут после еды',
        },
      },
    },
    adapt: {
      busy: 'Занятой день',
      travel: 'Режим путешествия',
      note: 'План упрощается автоматически',
    },
  },
  analytics: {
    title: 'Красивая Аналитика',
    description: 'Отслеживайте свой прогресс с помощью интуитивных графиков и дашбордов',
    currentMetrics: 'Текущие метрики',
    weeklyDynamics: 'Динамика за неделю',
    improvementTrends: 'Тренды улучшения',
    energy: 'Энергия',
    sleepQuality: 'Качество сна',
    activity: 'Физическая активность',
    recovery: 'Восстановление',
    sleep: 'Сон',
    averageEnergy: 'Средняя энергия',
    sleepQualityLabel: 'Качество сна',
    recoveryLabel: 'Восстановление',
    period: 'за 3 месяца',
    days: {
      mon: 'Пн',
      tue: 'Вт',
      wed: 'Ср',
      thu: 'Чт',
      fri: 'Пт',
      sat: 'Сб',
      sun: 'Вс',
    },
  },
  howItWorks: {
    title: 'Как это работает',
    description: 'Три простых шага к лучшему здоровью',
    step1: {
      title: 'Подключите устройства',
      description: 'Синхронизируйте Apple Health, Oura Ring, WHOOP или другие трекеры. Приложение автоматически начнет собирать данные о вашем сне, активности и здоровье.',
    },
    step2: {
      title: 'Получайте план каждый день',
      description: 'AI анализирует ваши данные и каждое утро предлагает 3 простые задачи. Никакой перегрузки - только то, что действительно важно для вашего здоровья.',
    },
    step3: {
      title: 'Отслеживайте прогресс',
      description: 'Смотрите красивые графики, изучайте материалы, общайтесь с комьюнити. Наблюдайте, как ваше здоровье улучшается день за днем.',
    },
  },
  pricing: {
    title: 'Простая цена',
    description: 'Дешевле, чем чашка кофе в день',
    popular: 'ПОПУЛЯРНЫЙ',
    features: [
      'Персональный план действий на каждый день',
      'Интеграция с Apple Health / Oura / WHOOP',
      'База знаний и образовательный контент',
      'Аналитика и дашборды',
      'Автоматическая расшифровка анализов',
      'Доступ к закрытому комьюнити',
      '100% автоматический сервис',
    ],
    startFree: 'Начать 7 дней бесплатно',
    note: 'Первую неделю бесплатно, затем $99/мес. Отменить можно в любой момент.',
  },
  community: {
    title: 'Индивидуальный подход к долголетию',
    description: 'Персональные консультации и рекомендации для продления жизни и сокращения биологического возраста на основе анализа ваших уникальных данных',
    biomarker: {
      title: 'Анализ биомаркеров',
      description: 'Глубокий анализ ваших данных для определения биологического возраста',
    },
    recommendations: {
      title: 'Персональные рекомендации',
      description: 'Индивидуальные советы на основе ваших уникальных метрик',
    },
    knowledge: {
      title: 'База знаний',
      description: 'Доступ к эксклюзивным материалам, исследованиям и гайдам',
    },
    plan: {
      title: 'План долголетия',
      description: 'Персонализированный план для продления жизни и улучшения здоровья',
    },
    consultations: {
      title: 'Консультации с экспертами',
      description: 'Получите персональные рекомендации от сертифицированных специалистов для максимально эффективного пути к долголетию',
    },
    trainer: {
      title: 'Тренер',
      description: 'Персональные программы тренировок, адаптированные под ваш уровень подготовки и цели долголетия',
    },
    nutritionist: {
      title: 'Нутриолог',
      description: 'Индивидуальный план питания с учетом ваших биомаркеров, пищевых предпочтений и целей здоровья',
    },
    doctor: {
      title: 'Врач',
      description: 'Медицинские консультации и интерпретация анализов для комплексного подхода к продлению жизни',
    },
    personalPlanTitle: 'Что включает персональный план',
    benefits: [
      'Персональные рекомендации на основе ваших данных',
      'AI-анализ биомаркеров для продления жизни',
      'Индивидуальный план по сокращению биологического возраста',
      'Доступ к научным исследованиям о долголетии',
    ],
    startJourney: 'Начните свой путь к долголетию',
    joinDescription: 'Присоединяйтесь к waitlist и получите ранний доступ к персональным рекомендациям',
    join: 'Присоединиться',
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    description: 'Все, что вам нужно знать о Juvenis',
    questions: [
      {
        question: 'Это замена врачу?',
        answer: 'Нет. Это продукт для lifestyle/лонгевити-рутины и принятия решений, не для диагностики и лечения.',
      },
      {
        question: 'Нужны ли гаджеты (Oura/WHOOP)?',
        answer: 'Нет. Можно начать с чек-инов и базовых данных, но с wearables точнее.',
      },
      {
        question: 'Как вы считаете Bio Age?',
        answer: 'Это индекс-ориентир, который показывает динамику, а не медицинский диагноз.',
      },
      {
        question: 'Будет ли персональный менеджер?',
        answer: 'В этом плане — нет выделенного менеджера. Всё автоматизировано для максимальной эффективности.',
      },
      {
        question: 'Как быстро я увижу эффект?',
        answer: 'Обычно первые улучшения — в рутине и ясности уже в первую неделю.',
      },
      {
        question: 'Можно отменить?',
        answer: 'Да, в 1 клик. Никаких вопросов.',
      },
      {
        question: 'Что с приватностью?',
        answer: 'Мы не продаём данные и используем их только для работы продукта.',
      },
    ],
  },
  cta: {
    title: 'Начните свой путь к долголетию сегодня',
    description: 'Начните свой путь к долголетию сегодня. Первая неделя бесплатно.',
    tryFree: 'Попробовать бесплатно',
    note: 'Без кредитной карты. Отменить можно в любой момент.',
  },
  phoneMockup: {
    progress: 'Прогресс',
    goodMorning: 'Доброе утро!',
    date: 'Пятница, 30 января',
    yourPlanToday: 'Ваш план на сегодня',
    task1: 'Свет в глаза до 10:00',
    task1Status: 'Выполнено',
    task2: 'Прогулка 20 мин',
    task2Status: 'В процессе',
    task3: 'Магний перед сном',
    task3Status: 'Запланировано • 22:00',
    sleep: 'Сон',
    energy: 'Энергия',
    myPlan: 'Мой план',
    analytics: 'Аналитика',
    materials: 'Материалы',
    profile: 'Профиль',
  },
  footer: {
    tagline: 'Твой Longevity Co-pilot',
    product: 'Продукт',
    company: 'Компания',
    support: 'Поддержка',
    about: 'О нас',
    blog: 'Блог',
    career: 'Карьера',
    help: 'Помощь',
    contacts: 'Контакты',
    privacy: 'Политика конфиденциальности',
    termsOfUse: 'Условия использования',
    copyright: '© 2026 Juvenis. Все права защищены.',
  },
  terms: {
    title: 'Условия использования',
    lastUpdated: 'Последнее обновление: 3 февраля 2026',
    welcome: 'Добро пожаловать в Juvenis! Эти Условия использования ("Условия") регулируют ваш доступ к веб-сайту juvenis.app, нашей платформе и связанным сервисам (совместно именуемым "Сервис"), предоставляемым Juvenis ("Компания", "мы", "нас" или "наш").',
    agree: 'Получая доступ к Сервису или используя его, вы соглашаетесь соблюдать эти Условия. Если вы не согласны с какой-либо частью Условий, вы не можете использовать Сервис.',
    section1Title: '1. Важное уведомление: Сервис не предоставляет медицинские консультации',
    section1Warning: 'НАШ СЕРВИС НЕ ЯВЛЯЕТСЯ ЗАМЕНОЙ ПРОФЕССИОНАЛЬНОЙ МЕДИЦИНСКОЙ КОНСУЛЬТАЦИИ, ДИАГНОСТИКИ ИЛИ ЛЕЧЕНИЯ. ИНФОРМАЦИЯ, РЕКОМЕНДАЦИИ И ПЛАНЫ, СОЗДАННЫЕ НАШЕЙ ПЛАТФОРМОЙ НА ОСНОВЕ ВАШИХ ДАННЫХ, ПРЕДОСТАВЛЯЮТСЯ ТОЛЬКО В ИНФОРМАЦИОННЫХ И ОБРАЗОВАТЕЛЬНЫХ ЦЕЛЯХ.',
    section1Acknowledge: 'Вы признаете и соглашаетесь с тем, что:',
    section1List1: 'Вы всегда должны консультироваться с квалифицированным врачом или другим медицинским работником по любым вопросам, касающимся вашего медицинского состояния или здоровья.',
    section1List2: 'Никогда не игнорируйте профессиональные медицинские советы и не откладывайте обращение за ними из-за того, что вы прочитали или получили через наш Сервис.',
    section1List3: 'Любые решения, которые вы принимаете на основе информации от Juvenis, принимаются исключительно на ваш собственный риск. Мы не несем ответственности за любые действия или бездействие с вашей стороны.',
    section1List4: 'Если вы считаете, что у вас может быть неотложная медицинская ситуация, немедленно обратитесь к врачу или в службу экстренной помощи.',
    section2Title: '2. Описание Сервиса',
    section2Text: 'Juvenis — это платформа, которая использует предоставленные вами данные (включая результаты анализов крови, генетические данные и информацию об образе жизни) для создания персонализированных рекомендаций и планов, направленных на оптимизацию вашего здоровья и долголетия. Сервис также может способствовать установлению связей с независимыми врачами и тренерами ("Специалисты").',
    section3Title: '3. Обязанности пользователя',
    section3Text: 'Вы несете единоличную ответственность за:',
    section3List1: 'Точность, полноту и достоверность всех данных, которые вы предоставляете Сервису.',
    section3List2: 'Обеспечение того, что вы получили все данные законным путем и имеете право делиться ими с нами.',
    section3List3: 'Сохранение конфиденциальности информации вашей учетной записи.',
    section3List4: 'Самостоятельную оценку и действия на основе рекомендаций Сервиса, желательно после консультации с вашим лечащим врачом.',
    section4Title: '4. Связь со сторонними специалистами',
    section4Text: 'Платформа может помочь вам связаться с независимыми Специалистами. Вы понимаете, что:',
    section4List1: 'Juvenis действует исключительно как технологическая платформа для облегчения этой связи. Мы не нанимаем и не контролируем этих Специалистов.',
    section4List2: 'Мы не несем ответственности за качество, точность, своевременность или законность советов и услуг, предоставляемых этими Специалистами.',
    section4List3: 'Любые отношения, которые вы устанавливаете со Специалистом, являются прямыми отношениями между вами и ним. Все претензии, связанные с их услугами, должны быть направлены Специалисту.',
    section5Title: '5. Ограничение ответственности',
    section5Warning: 'В МАКСИМАЛЬНОЙ СТЕПЕНИ, РАЗРЕШЕННОЙ ЗАКОНОМ, КОМПАНИЯ, ЕЕ АФФИЛИРОВАННЫЕ ЛИЦА, ДИРЕКТОРА И СОТРУДНИКИ НЕ НЕСУТ ОТВЕТСТВЕННОСТИ ЗА ЛЮБЫЕ КОСВЕННЫЕ, СЛУЧАЙНЫЕ, СПЕЦИАЛЬНЫЕ, ПОСЛЕДУЮЩИЕ ИЛИ ШТРАФНЫЕ УБЫТКИ ИЛИ ЛЮБУЮ ПОТЕРЮ ПРИБЫЛИ, ДАННЫХ ИЛИ ЗДОРОВЬЯ, ПОНЕСЕННЫЕ ПРЯМО ИЛИ КОСВЕННО, В РЕЗУЛЬТАТЕ:',
    section5List1: 'ВАШЕГО ИСПОЛЬЗОВАНИЯ ИЛИ НЕВОЗМОЖНОСТИ ИСПОЛЬЗОВАТЬ СЕРВИС;',
    section5List2: 'ЛЮБЫХ РЕКОМЕНДАЦИЙ ИЛИ ИНФОРМАЦИИ, ПОЛУЧЕННОЙ ЧЕРЕЗ СЕРВИС;',
    section5List3: 'ПОВЕДЕНИЯ ИЛИ СОВЕТОВ ЛЮБЫХ СТОРОННИХ СПЕЦИАЛИСТОВ;',
    section5List4: 'НЕСАНКЦИОНИРОВАННОГО ДОСТУПА, ИСПОЛЬЗОВАНИЯ ИЛИ ИЗМЕНЕНИЯ ВАШИХ ДАННЫХ.',
    section5Text: 'НАША СОВОКУПНАЯ ОТВЕТСТВЕННОСТЬ ПЕРЕД ВАМИ ПО ВСЕМ ПРЕТЕНЗИЯМ, СВЯЗАННЫМ СО СЕРВИСОМ, ОГРАНИЧИВАЕТСЯ СУММОЙ, УПЛАЧЕННОЙ ВАМИ, ЕСЛИ ТАКОВАЯ БЫЛА, ЗА ИСПОЛЬЗОВАНИЕ СЕРВИСА В ТЕЧЕНИЕ 12-МЕСЯЧНОГО ПЕРИОДА, ПРЕДШЕСТВУЮЩЕГО ПРЕТЕНЗИИ.',
    section6Title: '6. Отказ от гарантий',
    section6Text: 'СЕРВИС ПРЕДОСТАВЛЯЕТСЯ "КАК ЕСТЬ" И "ПО МЕРЕ ДОСТУПНОСТИ", БЕЗ КАКИХ-ЛИБО ГАРАНТИЙ ЛЮБОГО РОДА, ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ. МЫ НЕ ГАРАНТИРУЕМ, ЧТО СЕРВИС БУДЕТ НЕПРЕРЫВНЫМ, БЕЗОПАСНЫМ ИЛИ БЕЗ ОШИБОК, ИЛИ ЧТО РЕЗУЛЬТАТЫ, ПОЛУЧЕННЫЕ ОТ ЕГО ИСПОЛЬЗОВАНИЯ, БУДУТ ТОЧНЫМИ, НАДЕЖНЫМИ ИЛИ СООТВЕТСТВУЮТ ВАШИМ ОЖИДАНИЯМ.',
    section7Title: '7. Интеллектуальная собственность',
    section7Text: 'Весь контент, товарные знаки, логотипы и программное обеспечение, связанные с Сервисом, являются собственностью Компании или ее лицензиаров и защищены законами об интеллектуальной собственности.',
    section8Title: '8. Изменение и прекращение',
    section8Text: 'Мы оставляем за собой право изменять эти Условия в любое время. Мы также можем приостановить или прекратить ваш доступ к Сервису по любой причине без предварительного уведомления.',
    section9Title: '9. Применимое право',
    section9Text: 'Эти Условия регулируются и толкуются в соответствии с законами ОАЭ, без учета принципов коллизионного права.',
    section10Title: '10. Контактная информация',
    section10Text: 'Если у вас есть вопросы об этих Условиях, пожалуйста, свяжитесь с нами по адресу contact@juvenis.app',
    backToHome: 'Вернуться на главную',
  },
  privacy: {
    title: 'Политика конфиденциальности',
    lastUpdated: 'Последнее обновление: 3 февраля 2026',
    intro: 'Juvenis ("Компания", "мы", "нас" или "наш") обязуется защищать вашу конфиденциальность. Эта Политика конфиденциальности объясняет, как мы собираем, используем, раскрываем и защищаем вашу информацию при использовании нашего Сервиса.',
    section1Title: '1. Информация, которую мы собираем',
    section1Text: 'Мы можем собирать следующие категории информации:',
    section1List1Label: 'Персональная идентифицирующая информация:',
    section1List1Text: 'Ваше имя, адрес электронной почты, дата рождения и другие контактные данные, которые вы предоставляете при регистрации.',
    section1List2Label: 'Информация о здоровье и генетике:',
    section1List2Text: 'Результаты анализов крови, генетические данные, информация о диагнозах, лекарствах, семейном анамнезе и другие данные, связанные со здоровьем, которые вы загружаете или предоставляете.',
    section1List3Label: 'Информация об образе жизни:',
    section1List3Text: 'Данные о вашем питании, физической активности, режиме сна, уровне стресса и других привычках.',
    section1List4Label: 'Техническая информация:',
    section1List4Text: 'IP-адрес, тип браузера, операционная система, файлы cookie и данные об использовании, связанные с нашим веб-сайтом и платформой.',
    section2Title: '2. Как мы используем вашу информацию',
    section2Text: 'Мы используем собираемую информацию для:',
    section2List1Label: 'Предоставления и персонализации Сервиса:',
    section2List1Text: 'Для анализа ваших данных и создания вашего персонализированного плана долголетия и рекомендаций.',
    section2List2Label: 'Общения с вами:',
    section2List2Text: 'Для отправки уведомлений, обновлений и ответа на ваши запросы.',
    section2List3Label: 'Улучшения нашего Сервиса:',
    section2List3Text: 'Мы можем использовать анонимизированные и агрегированные данные для исследований, анализа тенденций и улучшения наших алгоритмов и предложений.',
    section2List4Label: 'Связи вас со специалистами:',
    section2List4Text: 'С вашего явного согласия мы можем делиться частями вашей информации со Специалистом, которого вы выбираете для консультации.',
    section2List5Label: 'Юридических целей:',
    section2List5Text: 'Для соблюдения юридических обязательств и защиты наших прав.',
    section3Title: '3. Как мы делимся вашей информацией',
    section3Text: 'Мы не продаем и не сдаем в аренду вашу личную информацию о здоровье или генетическую информацию третьим лицам без вашего явного согласия, за исключением следующих случаев:',
    section3List1Label: 'Поставщики услуг:',
    section3List1Text: 'Мы можем делиться информацией с доверенными сторонними поставщиками, которые помогают нам вести бизнес (например, поставщики облачного хранилища), при условии, что они соблюдают строгие обязательства по конфиденциальности.',
    section3List2Label: 'Специалисты:',
    section3List2Text: 'С вашего прямого разрешения мы поделимся необходимой информацией со Специалистом, с которым вы выбираете связаться через нашу платформу.',
    section3List3Label: 'Анонимизированные данные:',
    section3List3Text: 'Мы можем делиться анонимизированными и агрегированными данными (которые не могут быть использованы для вашей идентификации) с партнерами по исследованиям.',
    section3List4Label: 'Юридические требования:',
    section3List4Text: 'Мы можем раскрыть вашу информацию, если это требуется по закону, судебному решению или в ответ на действительный запрос государственного органа.',
    section4Title: '4. Безопасность данных',
    section4Text: 'Мы применяем коммерчески разумные технические и организационные меры для защиты вашей информации от несанкционированного доступа, изменения, раскрытия или уничтожения. Однако ни один метод передачи через Интернет или электронное хранение не является на 100% безопасным. Поэтому мы не можем гарантировать абсолютную безопасность.',
    section5Title: '5. Ваши права и выбор',
    section5Text: 'В зависимости от вашей юрисдикции, вы можете иметь следующие права:',
    section5List1Label: 'Право на доступ:',
    section5List1Text: 'Вы можете запросить копию информации, которую мы храним о вас.',
    section5List2Label: 'Право на исправление:',
    section5List2Text: 'Вы можете запросить исправление неточной или неполной информации.',
    section5List3Label: 'Право на удаление:',
    section5List3Text: 'Вы можете запросить удаление вашей учетной записи и связанной информации.',
    section6Title: '6. Конфиденциальность детей',
    section6Text: 'Наш Сервис не предназначен для лиц младше 18 лет. Мы сознательно не собираем личную информацию от детей.',
    section7Title: '7. Изменения в этой Политике',
    section7Text: 'Мы можем время от времени обновлять эту Политику конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую Политику на этой странице.',
    section8Title: '8. Контактная информация',
    section8Text: 'Если у вас есть вопросы или опасения по поводу нашей Политики конфиденциальности, пожалуйста, свяжитесь с нами по адресу contact@juvenis.app',
    backToHome: 'Вернуться на главную',
  },
  waitlist: {
    badge: 'Скоро запуск',
    title: 'Ваш путь к',
    titleHighlight: 'долголетию',
    titleEnd: 'начинается здесь',
    description: 'Станьте одним из первых, кто получит доступ к',
    descriptionHighlight: 'персональному плану долголетия',
    descriptionEnd: ', основанному на научных данных и анализе ваших биомаркеров.',
    emailPlaceholder: 'your@email.com',
    join: 'Присоединиться',
    privacy: 'Мы не передаем ваши данные третьим лицам. Только важные обновления о запуске.',
    success: 'Вы в списке!',
    successDescription: 'Персональный менеджер свяжется с вами в ближайшее время.',
    back: '← Вернуться на главную',
    errorSending: 'Произошла ошибка при отправке',
    errorConnection: 'Не удалось отправить email. Проверьте подключение к серверу.',
    agreeToTerms: 'Я согласен с',
    privacyPolicy: 'Политикой конфиденциальности',
    and: 'и',
    termsOfUse: 'Условиями использования',
    invalidEmail: 'Введите корректный email адрес',
  },
}
